<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      <img
        v-bind:src="getUserPhoto()"
        class="img-avatar"/>
    </template>
    <template slot="dropdown">
      <!--<b-dropdown-header-->
        <!--tag="div"-->
        <!--class="text-center">-->
        <!--<strong>{{$t('global.settings')}}</strong>-->
      <!--</b-dropdown-header>-->
      <!--<b-dropdown-item><i class="fa fa-user"/> Profile</b-dropdown-item>-->
      <!--<b-dropdown-item>-->
        <!--<i class="fa fa-wrench"/>-->
        <!--<router-link >{{$t('resources.edit_resource')}}</router-link>-->
      <!--</b-dropdown-item>-->
      <b-dropdown-item>
          <i class="fa fa-lock"/>
          <b-button variant="link" @click="logOut" class="p-0">{{$t('global.logout')}}</b-button>
      </b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>

  import {HeaderDropdown as AppHeaderDropdown} from '@coreui/vue'
  import {get} from 'lodash';

  export default {
    name: 'DefaultHeaderDropdownAccnt',
    components: {
      AppHeaderDropdown
    },
      methods: {
        getUserPhoto()
        {
            return get(this.user, 'photos.image_300')
        },
        async logOut()
        {
            await this.$store.dispatch('auth/logout');
            await this.$store.dispatch('resource/deleteDefaultResource');
            this.$router.push({name: 'Login'});
        }
        },
        mounted: function ()
        {
          this.user = this.$store.getters['auth/user'];
        },
        data: () => {
          return {
              itemsCount: 42,
              user : {}
          }
        }
  }
</script>
